<script setup>
import { defineProps, ref } from 'vue'
import { useGlobalStore } from '@/store'
import { useSmoothScroll } from '@/composables/useSmoothScroll'
import StepOne from '@/components/Steps/StepOne.vue'
import StepTwo from '@/components/Steps/StepTwo.vue'
import StepThree from '@/components/Steps/StepThree.vue'
import StepFour from '@/components/Steps/StepFour.vue'

const friendlyCaptcha = ref(null)
const globalStore = useGlobalStore()
const props = defineProps({
  activeStep: {
    type: Number,
    default: 1
  }
})
const { scrollToId } = useSmoothScroll()

function handleStepChange (isForward)
{
  if (isForward) {
    globalStore.goToNextStep()
  }
  else {
    globalStore.goToStep(globalStore.activeStep - 1)
  }

  if (!globalStore.isErrorState) {
    scrollToId('reward-campaign', 175)
  }
}

function handleFormSubmit () {
  const friendlyCap = friendlyCaptcha.value

  if (friendlyCap)
  {
    const captchaSolutionElement = friendlyCap.querySelector('.frc-captcha-solution')
    const captchaSolution = captchaSolutionElement ? captchaSolutionElement.value : null
    const successContainer = friendlyCap.querySelectorAll('.frc-container.frc-success')

    if (captchaSolution && captchaSolution !== '.UNFINISHED' && captchaSolution !== '.UNSTARTED' && successContainer && successContainer.length) {
      globalStore.handleSubmit(captchaSolution)
    }
  }
}
</script>
<template>
  <div class="reward-campaign__form-view" :class="{'-is-error-state': globalStore.isErrorState}">
    <div class="form-view--steps-wrapper">
      <div @click="globalStore.goToStep(1)" class="form-view--step-first" :class="{'-is-active-step' : props.activeStep === 1}">
        <span class="step-name heading bold">{{ $t('stepOne.title') }}</span>
        <div class="mobile-step">
          <span class="heading bold">1</span>
        </div>
        <div class="triangle-right"></div>
      </div>
      <div @click="globalStore.goToStep(2)" class="form-view--step-second" :class="{'-is-active-step' : props.activeStep === 2}">
        <span class="step-name heading bold">{{ $t('stepTwo.title') }}</span>
        <div class="mobile-step">
          <span class="heading bold">2</span>
        </div>
        <div class="triangle-right"></div>
      </div>
      <div @click="globalStore.goToStep(3)" class="form-view--step-third" :class="{'-is-active-step' : props.activeStep === 3}">
        <span class="step-name heading bold">{{ $t('stepThree.title') }}</span>
        <div class="mobile-step">
          <span class="heading bold">3</span>
        </div>
        <div class="triangle-right"></div>
      </div>
      <div @click="globalStore.goToStep(4)" class="form-view--step-fourth" :class="{'-is-active-step' : props.activeStep === 4}">
        <span class="step-name heading bold">{{ $t('stepFour.title') }}</span>
        <div class="mobile-step">
          <span class="heading bold">4</span>
        </div>
      </div>
    </div>
    <form class="form form-view--active-step-wrapper">
      <StepOne v-if="props.activeStep === 1" />
      <StepTwo v-if="props.activeStep === 2" />
      <StepThree v-if="props.activeStep === 3" />
      <StepFour v-if="props.activeStep === 4" />

      <div class="form-view--step-actions">
        <div class="-btn -btn-zeta" :class="{'-not-visible': props.activeStep === 1}" @click="handleStepChange(false)">
          <span>{{ $t('navigation.back') }}</span>
        </div>
        <div class="-btn -btn-alpha" v-if="props.activeStep < 4" @click="handleStepChange(true)">
          <span>{{ $t('navigation.forward') }} {{props.activeStep + 1}}</span>
        </div>
        <div @click="handleFormSubmit" class="-btn -btn-alpha" v-if="props.activeStep === 4">
          <span>{{ $t('navigation.send') }}</span>
        </div>
      </div>
      <div class="form-view--step-footer" :class="{'-no-step-footer': props.activeStep === 3}">
        <span v-if="props.activeStep !== 3">* {{ $t('footer.required') }}</span>
      </div>
      <div ref="friendlyCaptcha" v-if="globalStore.frcSitekey" class="frc-captcha" :data-sitekey="globalStore.frcSitekey"></div>
    </form>
  </div>
</template>
